import $ from 'jquery';

$(document).ready(() => {
  const $selects = $('.js-select');

  if (!$selects) {
    return;
  }

  require.ensure(['select2/dist/js/select2'], (require) => {
    require('select2/dist/js/select2');

    $selects.select2({
      minimumResultsForSearch: Infinity,
    });
  });

  $('#langSelect').on('select2:select', (e) => {
    const { id } = e.params.data;
    if (id) {
      window.location.replace(id);
    }
  });
});
